import { useLazyQuery } from '@apollo/client';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import { BillingCycleFilterInput } from '@/graphql/contracts/_generated_/contracts';
import {
  GetPaginatedFilteredBillingCycles,
  GetPaginatedFilteredBillingCyclesVariables,
} from '@/graphql/contracts/_generated_/getPaginatedFilteredBillingCycles.query';
import GetPaginatedBillingCyclesQuery from '@/graphql/contracts/getPaginatedFilteredBillingCycles.query.gql';
import { PaginatedFilteredGridData } from '@/utils/data-helpers/PaginatedFilteredGridData';

export type PaginatedFilteredBillingCycles = PaginatedFilteredGridData<BillingCycleFilterInput>;

export default function useGetBillingCycles() {
  const [_getBillingCycles] = useLazyQuery<
  GetPaginatedFilteredBillingCycles,
  GetPaginatedFilteredBillingCyclesVariables
  >(GetPaginatedBillingCyclesQuery, {
    client: apolloClientContracts,
    fetchPolicy: 'network-only',
    onError: (err) => {
      console.error('Error fetching billing cycles:', err.message);
    },
  });

  const getBillingCycles = async (params: PaginatedFilteredBillingCycles) => {
    const response = await _getBillingCycles({
      variables: {
        ...params,
      } as GetPaginatedFilteredBillingCyclesVariables,
    });
    return response.data?.paginatedFilteredBillingCycles;
  };

  return {
    getBillingCycles,
  };
}
